<template>
  <div :id="isMobile?'mobileApp':'app'" :style="{paddingTop:feedNav?'60px':'0px'}" ref="vueDom" style="display: none;">
    <router-view/>
  </div>
</template>

<script>
    import {isMobile} from "@/utils";
    import {mapGetters} from 'vuex'

    export default {
        name: 'App',
        computed: {
            isMobile() {
                return isMobile()
            },
            ...mapGetters(['feedNav'])
        },
        data(){
          return {
            //监听浏览器的关闭
             beforeUnload: '',
             Handler: ''
          }
        },
        mounted() {
            setTimeout(() => {
                this.$refs.vueDom.style.display = 'block'
            })
            this.$nextTick(()=> {
              window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
              // window.addEventListener('unload', e => this.unloadHandler(e))
            })

        },
        destroyed() {
          window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
          // window.removeEventListener('unload', e => this.unloadHandler(e))
        },
        methods: {
          beforeunloadHandler(e){
              this.beforeUnload=new Date().getTime();
            //   e = e || window.event
            //   if (e) {
            //     e.returnValue = '您是否确认离开此页面-您输入的数据可能不会被保存'
            //   }
            // return '您是否确认离开此页面-您输入的数据可能不会被保存'
          },
          unloadHandler(){
            this.Handler=new Date().getTime()-this.beforeUnload;
                //判断是窗口关闭还是刷新
                if(this.Handler<=5){
                 this.$store.dispatch('user/logout')
                 console.log('为所欲为');
                }
              },
        }
    }
</script>

<style>
  @import 'assets/iconfont/iconfont.css';
  @import 'assets/style/common1200.css';
  @import "assets/style/tgl.css";

  #app,#mobileApp {
    font-family:  -apple-system,BlinkMacSystemFont,segoe ui,Roboto,helvetica neue,Arial,noto sans,sans-serif,apple color emoji,segoe ui emoji,segoe ui symbol,noto color emoji !important;
  }
  button, input, optgroup, select, textarea{
    font-family: -apple-system,BlinkMacSystemFont,segoe ui,Roboto,helvetica neue,Arial,noto sans,sans-serif,apple color emoji,segoe ui emoji,segoe ui symbol,noto color emoji !important;
  }
</style>

<style lang="less">
  // @import "assets/style/mobile.less";
</style>



// WEBPACK FOOTER //
// src/App.vue